import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
  Button,
  CircularProgress,
  MenuItem,
  TextField
} from "@material-ui/core";

import { PageContext } from "../../contexts/PageContext";
import { UserContext } from "../../contexts/UserContext";


const AddCredit = (props) => {
  const emptyCredit = { title: "", type: "hypothekar", subtype: "", status: "draft" };
  const [newCredit, setNewCredit] = useState({ ...emptyCredit });
  const [loadingStep, setLoadingStep] = useState(0);
  const pageContext = useContext(PageContext);
  const userContext = useContext(UserContext);
  const loadingSteps = [
    "",
    "Finanzierung wird angelegt",
    "Banken werden eingerichtet",
    "Berechtigungen werden gesetzt",
    "Eingabefelder werden vorbereitet",
    "einen Moment bitte..."
  ];


  const addCredit = () => {
    setLoadingStep(1);
    setTimeout(() => { setLoadingStep(2) }, 3000);
    setTimeout(() => { setLoadingStep(3) }, 6000);
    setTimeout(() => { setLoadingStep(4) }, 9000);
    setTimeout(() => { setLoadingStep(5) }, 12000);
    const options = {
      url: `${process.env.REACT_APP_API_SERVICE_URL}/credits`,
      data: newCredit,
      method: 'post',
      headers: userContext.getRequestAuthHeader()
    };
    axios(options)
      .then((res) => {
        setNewCredit({ ...emptyCredit });
        props.setAddCreditDialogOpen(false);

        if (props.newCreditCallback)
          props.newCreditCallback(res.data);

        pageContext.setInfoMessage(
          "Erledigt! Finanzierungsantrag " +
          newCredit.title +
          " wurde angelegt."
        );
      })
      .catch((err) => {
        console.log(err);
        pageContext.setErrorMessage("Finanzierungsantrag konnte nicht angelegt werden!");
      });
  }

  useEffect(() => {
    if (props.addCreditDialogOpen === true) {
      setNewCredit({ ...emptyCredit });
      setLoadingStep(0);
    }
  }, [props.addCreditDialogOpen]);

  return (
    <Dialog
      open={props.addCreditDialogOpen === true}
      onClose={() => {
        props.setAddCreditDialogOpen(false);
      }}
      aria-labelledby="form-dialog-title"
      maxWidth="xs"
    >
      <DialogTitle id="form-dialog-title">Neue Finanzierung</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Gib dem Antrag eine aussagekräftige Bezeichnung
        </DialogContentText>
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="center"
          alignItems="center">
          <Grid item xs={12}>
            <TextField
              label="Bezeichnung"
              name="title"
              id="title"
              value={newCredit.title ? newCredit.title : ""}
              required={true}
              helperText="zB Einfamilienhaus Familie Muster..."
              fullWidth
              disabled={loadingStep > 0}
              onChange={(e) => setNewCredit({ ...newCredit, [e.target.name]: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Typ"
              name="type"
              id="type"
              value={newCredit.type ? newCredit.type : "hypothekar"}
              required={true}
              fullWidth
              onChange={(e) => {
                if (e.target.value === "konsum") {
                  // reset subtype if Konsumkredit is selected
                  setNewCredit({ ...newCredit, [e.target.name]: e.target.value, subtype: "" });
                } else {
                  setNewCredit({ ...newCredit, [e.target.name]: e.target.value });
                }
              }}
              disabled={loadingStep > 0}
              select
            >
              <MenuItem value="hypothekar">Hypothekarkredit</MenuItem>
              <MenuItem value="konsum">Konsumkredit</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Zweck"
              name="subtype"
              id="subtype"
              value={newCredit.subtype ? newCredit.subtype : ""}
              required={true}
              fullWidth
              onChange={(e) => setNewCredit({ ...newCredit, [e.target.name]: e.target.value })}
              disabled={loadingStep > 0 || newCredit.type === "konsum"}
              select
            >
              <MenuItem value="">-</MenuItem>
              <MenuItem value="hauskauf">Hauskauf</MenuItem>
              <MenuItem value="wohnungskauf">Wohnungskauf</MenuItem>
              <MenuItem value="grundkauf">Grundkauf</MenuItem>
              <MenuItem value="hausbau">Hausbau</MenuItem>
              <MenuItem value="umbau">Umbau</MenuItem>
              <MenuItem value="umschuldung">Umschuldung</MenuItem>
            </TextField>
          </Grid>
          {loadingStep > 0 &&
            <>
              <Grid item xs={3} align="right">
                <CircularProgress size={24} />
              </Grid>
              <Grid item xs={9}>
                {loadingSteps[loadingStep]}
              </Grid>
            </>
          }
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.setAddCreditDialogOpen(false);
          }}
          variant="outlined"
          color="primary"
          disabled={loadingStep > 0}
        >
          Abbrechen
        </Button>
        <Button
          onClick={() => {
            addCredit();
          }}
          variant="outlined"
          color="primary"
          disabled={
            newCredit.title === "" || loadingStep > 0 || (newCredit.type === "hypothekar" && newCredit.subtype === "")
          }
        >
          Neue Finanzierung anlegen
        </Button>
      </DialogActions>
    </Dialog>
  )
};

export default AddCredit;